<template>
  <span class="badge" :class="badgeClass" :style="badgeStyle">{{ label }}</span>
</template>

<script>
import { SEVERITY_COLORS } from './constants.js';

export default {
  name: 'SeverityBadge',
  props: {
    severity: { type: String, required: true },
    small: { type: Boolean, default: false },
  },
  computed: {
    badgeClass() {
      const base = this.small ? 'badge-sm' : '';
      return [base, 'severity-badge', `severity-${this.severity.toLowerCase()}`];
    },
    badgeStyle() {
      return SEVERITY_COLORS[this.severity] || SEVERITY_COLORS.LOW;
    },
    label() {
      return this.severity;
    },
  },
};
</script>

<style scoped>
.severity-badge {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  border-radius: 3px;
  padding: 2px 6px;
}
.badge-sm {
  font-size: 0.6rem;
  padding: 1px 4px;
}
</style>
